module.exports = "/images/ny-life2-10.jpg";